import { EnvironmentConfig, ENVS } from './types';

const stagingConfig: EnvironmentConfig = {
  serverUrl: 'https://api.stg.omotenashi.ai/v1',
  environment: ENVS.STAGING,
  firebaseConfig: {
    apiKey: 'AIzaSyAO2PS9NtvgJH80IXHi46JwEgn_I28c7A8',
    authDomain: 'zeals-dx-stg.firebaseapp.com',
    databaseURL: 'https://zeals-dx-stg.firebaseio.com',
    projectId: 'zeals-dx-stg',
    storageBucket: 'zeals-dx-stg.appspot.com',
    messagingSenderId: '910369079356',
    appId: '1:910369079356:web:a59d030a8bc15872b1c339',
    measurementId: 'G-85H512NFNC',
  },
  tagManagerContainerId: 'GTM-PN7QG7T',
  sentryDst:
    'https://71877d57a4e14a1db2b974c56e9f0ecc@o247680.ingest.sentry.io/5544243',
  sentryEnabled: true,
  twilioConnectOptions: {
    tracks: [],
    maxAudioBitrate: 16000,
    // https://www.twilio.com/docs/video/tutorials/developing-high-quality-video-applications#mobile-browser-grid-recommended-settings
    bandwidthProfile: {
      video: {
        mode: 'presentation',
        maxTracks: 6, // the recommendation is 4 but since we have to switch some tracks between so having some buffer here
        maxSubscriptionBitrate: 2500000,
        dominantSpeakerPriority: 'standard',
        renderDimensions: {
          high: { height: 1080, width: 1920 },
          standard: { height: 640, width: 360 },
        },
      },
    },
    dominantSpeaker: true,
    preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
    networkQuality: { local: 3, remote: 1 },
  },
};

export default stagingConfig;
